const template5 = {
    banners: {
        sections: {
            1: {
                animationTypes: ['Horizontal', 'Fade'],
                animationSpeed: true,
                pagination: true,
                autoplay: true,
                arrows: true,
                counter: true
            },
            2: {
                animationTypes: ['Horizontal'],
                animationSpeed: true,
                autoplay: true,
                arrows: true,
                counter: false
            },
            3: {
                animationTypes: ['Horizontal', 'Fade'],
                animationSpeed: true,
                pagination: true,
                autoplay: true,
                arrows: false,
                counter: false
            },
            5: null
        },
        pages: {
            Mainpage: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    home_page_main_section: {
                        width: 1860,
                        height: 511
                    },
                    home_page_secondary_section: {
                        width: 516,
                        height: 208,
                        gridAvailable: true
                    },
                    home_page_top_casino_games_section: {
                        width: 385,
                        height: 240,
                        gridAvailable: true
                    },
                    home_page_top_live_casino_games_section: {
                        width: 385,
                        height: 240,
                        gridAvailable: true
                    },
                }
            },
            Casino: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    casino_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            CasinoHome: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    casino_home_secondary_section: {
                        width: 476,
                        height: 250,
                        gridAvailable: true
                    },
                }
            },
            LiveCasinopage: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    livecasino_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            RegistrationPage: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    registration_page_side_section: {
                        width: 392,
                        height: 600,
                        gridAvailable: true,
                        withNote: true
                    },
                }
            },
            LiveCasinoHome: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    live_casino_home_secondary_section: {
                        width: 476,
                        height: 250,
                        gridAvailable: true
                    },
                }
            },
            TVGamespage: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    tvgames_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            TVGamesHome: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    tv_games_home_secondary_section: {
                        width: 476,
                        height: 250,
                        gridAvailable: true
                    },
                }
            },
            VirtualSportpage: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    virtualsport_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            VirtualSportHome: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    virtual_sport_home_secondary_section: {
                        width: 476,
                        height: 250,
                        gridAvailable: true
                    },
                }
            },
            FastGames: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    fastgames_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            FastGamesHome: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    fast_games_home_secondary_section: {
                        width: 476,
                        height: 250,
                        gridAvailable: true
                    },
                }
            },
            CasinoTournaments: {
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    casino_tournaments_page_main_section: {
                        width: 1920,
                        height: 900
                    },
                }
            },
            MyProfile: {
                auth: true,
                settings: {
                    defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    myprofile_popup_main_section: {
                        width: 1329,
                        height: 90
                    },
                }
            },
            RegistrationPopup: {
                auth: true,
                type: 1,
                speceficType: 1,
                sportStatus: true,
                settings: {
                },
                sections: {
                    registration_popup_main_section: {
                        width: 328,
                        height: 90,
                        regAltText: true
                    },
                }
            },
            LoginPopup: {
                auth: true,
                speceficType: 1,
                sportStatus: true,
                settings: {
                },
                sections: {
                    login_popup_main_section: {
                        width: 328,
                        height: 90
                    },
                }
            },
            Join: {
                auth: true,
                speceficType: 1,
                speceficDeviceType: 2,
                sportStatus: true,
                settings: {
                },
                sections: {
                    join_popup_main_section: {
                        width: 992,
                        height: 90
                    },
                }
            },
             Sport: {
                settings: {
                      defaultAnimationSpeed: 5,
                    minAnimationSpeed: 0.5,
                    maxAnimationSpeed: 15
                },
                sections: {
                    sport_page_top_section: {
                        width: 610,
                        height: 836,
                        gridAvailable: true
                    },
                }
            },
        }
    },
    fonts: {
        fontFamily: {
            title: 'font_family',
            name: 'font-family-1',
            defaultValueIndex: 0,
            values: [
                { name: "'Roboto',sans-serif", label: "Roboto", sampleText: 'roboto.svg', fontText: 'roboto_font.svg' },
                { name: "Arial, Helvetica, sans-serif", label: "Arial", sampleText: 'arial.svg', fontText: 'arial_font.svg' },
                { name: "Impact, Charcoal, sans-serif", label: "Impact", sampleText: 'impact.svg', fontText: 'impact_font.svg' },
                { name: "Tahoma, Geneva, sans-serif", label: "Tahoma", sampleText: 'tahoma.svg', fontText: 'tahoma_font.svg' },
                { name: "Trebuchet MS, Helvetica, sans-serif", label: "Trebuchet MS", sampleText: 'trebuchet_ms.svg', fontText: 'trebuchet_ms_font.svg' },
                { name: "Verdana, Geneva, sans-serif", label: "Verdana", sampleText: 'verdana.svg', fontText: 'verdana_font.svg' },
                { name: "MS Sans Serif, Geneva, sans-serif", label: "MS Sans Serif", sampleText: 'ms_sans_serif.svg', fontText: 'ms_sans_serif_font.svg' },
                { name: "Curier New, Courier, monospace", label: "Curier New", sampleText: 'courier_new.svg', fontText: 'courier_new_font.svg' },
                { name: "Lucida Console, Monaco, monospace", label: "Lucida Console", sampleText: 'lucida_console.svg', fontText: 'lucida_console_font.svg' },
                { name: "Lucida Sans Unicode,Lucida Grande, monospace", label: "Lucida Sans Unicode", sampleText: 'lucida_sans_unicode.svg', fontText: 'lucida_sans_unicode_font.svg' },
                { name: "Georgia, serif", label: "Georgia", sampleText: 'georgia.svg', fontText: 'georgia_font.svg' },
                { name: "Times New Roman, Times, serif", label: "Times New Roman", sampleText: 'times_new_roman.svg', fontText: 'times_new_roman_font.svg' },
                { name: "Palatino Linotype,Book Antiqua,Palatino, serif", label: "Palatino Linotype", sampleText: 'palatino_linotype.svg', fontText: 'palatino_linotype_font.svg' },
                { name: "Comic Sans MS, cursive", label: "Comic Sans MS", sampleText: 'comic_sans_ms.svg', fontText: 'comic_sans_ms_font.svg' },
                { name: "'IRANSans', sans-serif", label: "Iranian Sans", sampleText: 'iran_sans.svg', fontText: 'iran_sans_font.svg' },
                { name: "'Open Sans', sans-serif", label: "Open Sans", sampleText: 'open_sans.svg', fontText: 'open_sans_font.svg' },
                { name: "'Ubuntu', sans-serif", label: "Ubuntu", sampleText: 'ubuntu.svg', fontText: 'ubuntu_font.svg' },
                { name: "'Poppins', sans-serif", label: "Poppins", sampleText: 'poppins.svg', fontText: 'poppins_font.svg' }
            ]
        }
    },
    cornerRadius: {
        'btn-radius-top-left': '2',
        'btn-radius-top-right': '2',
        'btn-radius-bottom-right': '2',
        'btn-radius-bottom-left': '2',

        'input-radius-top-left': '2',
        'input-radius-top-right': '2',
        'input-radius-bottom-right': '2',
        'input-radius-bottom-left': '2'
    },
    popupColors: {
        backgroundColors: {
            title: "background_colors",
            autoGenerate: true,
            bottomAxis: { start: 0, end: 50 },
            topAxis: { start: 50, end: 100 },
            list: [
                {
                    name: 'modal-bg-color-1',
                    value: '#ffffff',
                    visible: true,
                    generationStep: 0,
                },
                {
                    name: 'modal-bg-color-2',
                    value: '#f4f4f4',
                    visible: true,
                    generationStep: 5,
                },
                {
                    name: 'modal-bg-color-3',
                    value: '#e8e8e8',
                    visible: true,
                    generationStep: 10,
                },
                {
                    name: 'modal-bg-color-4',
                    value: '#c7c7c7',
                    visible: true,
                    generationStep: 15,
                }
            ]
        },
        textColors: {
            title: "text_colors",
            autoGenerate: true,
            bottomAxis: { start: 40, end: 60 },
            topAxis: { start: 60, end: 100 },
            list: [
                {
                    name: 'modal-text-color-1',
                    value: '#1a1a1a',
                    visible: true,
                    generationStep: 0
                },
                {
                    name: 'modal-text-color-2',
                    value: '#3d3d3d',
                    visible: true,
                    generationStep: 20
                },
                {
                    name: 'modal-text-color-3',
                    value: '#999999',
                    visible: true,
                    generationStep: 30
                }
            ]
        }
    },
    colors: {
        brandColors: {
            title: "brand_colors",
            list: [
                {
                    name: 'brand-color-1',
                    value: '#967FFD',
                    visible: true
                },
                {
                    name: 'brand-color-2',
                    value: '#7A71EB',
                    visible: true
                },
                {
                    name: 'brand-color-text',
                    value: '#fbfbfb',
                    visible: true
                }
            ]
        },

        backgroundColors: {
            title: "background_colors",
            autoGenerate: true,
            bottomAxis: { start: 0, end: 50 },
            topAxis: { start: 50, end: 100 },
            list: [
                {
                    name: 'background-color-1',
                    value: '#ffffff',
                    visible: true,
                    generationStep: 0,
                },
                {
                    name: 'background-color-2',
                    value: '#f7f7fe',
                    visible: true,
                    generationStep: 5,
                },
                {
                    name: 'background-color-3',
                    value: '#f7f7fe',
                    visible: true,
                    generationStep: 10,
                },
                {
                    name: 'background-color-4',
                    value: '#ffffff',
                    visible: true,
                    generationStep: 15,
                },
                {
                    name: 'background-color-5',
                    value: '#313234',
                    visible: true,
                    generationStep: 20,
                },
                {
                    name: 'background-color-6',
                    value: '#ebebfd',
                    visible: true,
                    generationStep: 25,
                }
            ]
        },
        textColors: {
            title: "text_colors",
            autoGenerate: true,
            bottomAxis: { start: 40, end: 60 },
            topAxis: { start: 60, end: 100 },
            list: [
                {
                    name: 'text-color-1',
                    value: '#2E3036',
                    visible: true,
                    generationStep: 0
                },
                {
                    name: 'text-color-2',
                    value: '#818285',
                    visible: true,
                    generationStep: 20
                },
                {
                    name: 'text-color-3',
                    value: '#bcbec5',
                    visible: true,
                    generationStep: 30
                },
                {
                    name: 'text-color-4',
                    value: '#818285',
                    visible: true,
                    generationStep: 40
                }
            ]
        }
    },
    backgroundImage: true,
    timezone: {
        allowPositionChange: false,
    }
}
export default template5;